import { Component, OnInit, Input } from '@angular/core';
import { HeaderConfig } from '../../../_models/header-config.model';
import { BaseUserService } from '../../../../services/base-user/base-user.service';

/** Topnav header component */
@Component({
  selector: 'lm-topnav-header',
  templateUrl: './topnav-header.component.html',
  styleUrls: ['./topnav-header.component.scss']
})
export class TopnavHeaderComponent implements OnInit {
  /** The header config object */
  @Input()
  public config: HeaderConfig;

  /** The title displayed on the header */
  public title: string;

  /**
   * @param userService - A reference to the user service
   */
  constructor(private userService: BaseUserService) {}

  /**
   * Method called when the component is initialized
   */
  public ngOnInit() {
    this.title = this.config.title;
  }

  /**
   * Method called when the user logs out
   */
  onLogout() {
    this.userService._logoutUser(this.config.logoutRoute);
  }
}
